import { BmOkContent } from '../content';
import { StageOfType } from './StageOfType';

type Stage = {
  keyword: string;
};

export class LegacyStage implements StageOfType<'legacy', Stage> {
  type = 'legacy' as const;

  constructor(private content: BmOkContent) {}

  get keyword() {
    return this.content.mainKeyword;
  }

  get image() {
    return this.content.stage?.image;
  }

  get headline() {
    return this.content.stage?.headline || '';
  }

  get includeSearch() {
    return this.content.stage?.includeSearch || false;
  }

  get pageTitle() {
    return this.content.stage?.pageTitle || '';
  }
}
